<template>
  <!-- TEXT SVG -->
  <svg
    v-if="icon === 'text'"
    class="h-full"
    viewBox="0 0 40 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 1V7C0 7.5625 0.4375 8 1 8C1.5 8 2 7.5625 2 7V2H11V26H7C6.4375 26 6 26.5 6 27C6 27.5625 6.4375 28 7 28H17C17.5 28 18 27.5625 18 27C18 26.5 17.5 26 17 26H13V2H22V7C22 7.5625 22.4375 8 23 8C23.5 8 24 7.5625 24 7V1C24 0.5 23.5 0 23 0H1C0.4375 0 0 0.5 0 1ZM20 13V17C20 17.5625 20.4375 18 21 18C21.5 18 22 17.5625 22 17V14H29V26H26C25.4375 26 25 26.5 25 27C25 27.5625 25.4375 28 26 28H34C34.5 28 35 27.5625 35 27C35 26.5 34.5 26 34 26H31V14H38V17C38 17.5625 38.4375 18 39 18C39.5 18 40 17.5625 40 17V13C40 12.5 39.5 12 39 12H21C20.4375 12 20 12.5 20 13Z"
      fill="currentColor"
    />
  </svg>

  <!-- SOCIAL SVG -->
  <svg
    v-if="icon === 'social'"
    class="h-full"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M28 5C28 7.8125 25.75 10 23 10C21.5625 10 20.25 9.4375 19.3125 8.4375L9.875 13.1875C9.9375 13.4375 10 13.75 10 14C10 14.3125 9.9375 14.625 9.875 14.875L19.3125 19.5625C20.25 18.625 21.5625 18 23 18C25.75 18 28 20.25 28 23C28 25.8125 25.75 28 23 28C20.1875 28 18 25.8125 18 23C18 22.4375 18.0625 21.8125 18.25 21.3125L9.1875 16.75C8.25 18.125 6.75 19 5 19C2.1875 19 0 16.8125 0 14C0 11.25 2.1875 9 5 9C6.75 9 8.25 9.9375 9.1875 11.3125L18.25 6.75C18.0625 6.1875 18 5.625 18 5C18 2.25 20.1875 0 23 0C25.75 0 28 2.25 28 5ZM4.9375 17C6.625 17 7.9375 15.6875 7.9375 14C7.9375 12.375 6.625 11 4.9375 11C3.3125 11 1.9375 12.375 1.9375 14C1.9375 15.6875 3.3125 17 4.9375 17ZM23 2C21.3125 2 20 3.375 20 5C20 6.6875 21.3125 8 23 8C24.625 8 26 6.6875 26 5C26 3.375 24.625 2 23 2ZM23 26C24.625 26 26 24.6875 26 23C26 21.375 24.625 20 23 20C21.3125 20 20 21.375 20 23C20 24.6875 21.3125 26 23 26Z"
      fill="currentColor"
    />
  </svg>

  <!-- VIDEO SVG -->
  <svg
    v-if="icon === 'video'"
    class="h-full"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.25 14.75C22.6875 15 23 15.5 23 16C23 16.5625 22.6875 17.0625 22.25 17.3125L13.25 22.8125C12.8125 23.0625 12.1875 23.125 11.75 22.8125C11.25 22.5625 11 22.0625 11 21.5V10.5C11 10 11.25 9.5 11.75 9.25C12.1875 8.9375 12.8125 8.9375 13.25 9.25L22.25 14.75ZM13 11.4375V20.625L20.5 16L13 11.4375ZM0 16C0 7.1875 7.125 0 16 0C24.8125 0 32 7.1875 32 16C32 24.875 24.8125 32 16 32C7.125 32 0 24.875 0 16ZM16 30C23.6875 30 30 23.75 30 16C30 8.3125 23.6875 2 16 2C8.25 2 2 8.3125 2 16C2 23.75 8.25 30 16 30Z"
      fill="currentColor"
    />
  </svg>

  <!-- DIVIDER SVG -->

  <svg
    v-if="icon === 'divider'"
    class="h-full"
    viewBox="0 0 40 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M39 15H1C0.4375 15 0 14.5625 0 14C0 13.5 0.4375 13 1 13H39C39.5 13 40 13.5 40 14C40 14.5625 39.5 15 39 15Z"
      fill="currentColor"
    />
    <path
      d="M25.7188 5.28125C26.0938 5.65625 26.0938 6.34375 25.7188 6.71875C25.3438 7.09375 24.6562 7.09375 24.2812 6.71875L20.9688 3.40625V24.5938L24.2812 21.2812C24.6562 20.9062 25.3438 20.9062 25.7188 21.2812C26.0938 21.6562 26.0938 22.3438 25.7188 22.7188L20.7188 27.7188C20.3438 28.0938 19.6562 28.0938 19.2812 27.7188L14.2812 22.7188C13.9062 22.3438 13.9062 21.6562 14.2812 21.2812C14.6562 20.9062 15.3438 20.9062 15.7188 21.2812L19.0312 24.5938V3.40625L15.7188 6.71875C15.3438 7.09375 14.6562 7.09375 14.2812 6.71875C13.9062 6.34375 13.9062 5.65625 14.2812 5.28125L19.2812 0.28125C19.6562 -0.09375 20.3438 -0.09375 20.7188 0.28125L25.7188 5.28125Z"
      fill="currentColor"
    />
  </svg>

  <!-- BUTTON SVG -->
  <svg
    v-if="icon === 'button'"
    class="h-full"
    viewBox="0 0 46 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0 4.25C0 1.90279 1.90279 0 4.25 0H41.75C44.0972 0 46 1.90279 46 4.25V15.75C46 18.0972 44.0972 20 41.75 20H38.5C37.9477 20 37.5 19.5523 37.5 19C37.5 18.4477 37.9477 18 38.5 18H41.75C42.9926 18 44 16.9926 44 15.75V4.25C44 3.00736 42.9926 2 41.75 2H4.25C3.00736 2 2 3.00736 2 4.25V15.75C2 16.9926 3.00736 18 4.25 18H21.75C22.3023 18 22.75 18.4477 22.75 19C22.75 19.5523 22.3023 20 21.75 20H4.25C1.90279 20 0 18.0972 0 15.75V4.25Z"
      fill="currentColor"
    />
    <path
      d="M25 12.7491V24.298C25 24.7038 25.2812 24.9847 25.6875 24.9847C25.875 24.9847 26.0625 24.9223 26.1875 24.7662L28.7812 21.8009L30.5938 25.4529C30.8438 25.9523 31.4375 26.1396 31.9375 25.8899C32.4375 25.6402 32.625 25.0471 32.375 24.5477L30.5938 20.9894H34.2812C34.6875 20.9894 35 20.7085 35 20.3027C35 20.1154 34.9062 19.9282 34.75 19.8033L26.1875 12.1873C26.0625 12.0936 25.875 12 25.7188 12C25.3125 12 25 12.3433 25 12.7491Z"
      fill="currentColor"
    />
  </svg>

  <!-- IMAGE SVG -->
  <svg
    v-if="icon === 'image'"
    class="h-full"
    viewBox="0 0 33 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.25 7.875C20.5625 6.8125 18.8125 6.8125 18.0625 7.875L13.5 14.8125L12.5 13.375C11.75 12.375 10.0625 12.375 9.375 13.375L5.3125 19C4.9375 19.5625 4.875 20.3125 5.1875 21C5.5 21.625 6.1875 22 6.875 22H27.0625C27.75 22 28.4375 21.625 28.75 21C29.0625 20.375 29.0625 19.625 28.625 19.0625L21.25 7.875ZM6.9375 20L10.875 14.5625L12.75 17.125C12.9375 17.4375 13.25 17.625 13.5625 17.5625C13.875 17.5625 14.1875 17.375 14.375 17.125L19.625 9L26.9375 20H6.9375ZM28.9375 0H4.9375C2.75 0 0.9375 1.8125 0.9375 4V24C0.9375 26.25 2.75 28 4.9375 28H28.9375C31.125 28 32.9375 26.25 32.9375 24V4C32.9375 1.8125 31.1875 0 28.9375 0ZM31 24C31 25.125 30.0625 26 29 26H5C3.875 26 3 25.125 3 24V4C3 2.9375 3.875 2 5 2H29C30.0625 2 31 2.9375 31 4V24ZM10 10C11.625 10 13 8.6875 13 7C13 5.375 11.625 4 10 4C8.3125 4 7 5.375 7 7C7 8.6875 8.3125 10 10 10ZM10 6C10.5 6 10.9375 6.5 10.9375 7C10.9375 7.5625 10.5 8 10 8C9.4375 8 9 7.5625 9 7C9 6.5 9.4375 6 10 6Z"
      fill="currentColor"
    />
  </svg>

  <!-- CODE SVG -->
  <svg
    v-if="icon === 'code'"
    class="h-full"
    viewBox="0 0 40 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M25.9375 1.37499L15.9375 31.375C15.75 31.875 15.1875 32.125 14.625 32C14.125 31.8125 13.875 31.25 14 30.6875L24 0.687494C24.1875 0.187494 24.75 -0.0625061 25.3125 0.0624939C25.8125 0.249994 26.0625 0.812494 25.9375 1.37499ZM10.625 8.74999L2.5 16L10.625 23.25C11.0625 23.625 11.0625 24.25 10.6875 24.6875C10.375 25.125 9.6875 25.125 9.3125 24.75L0.3125 16.75C0.0625 16.5625 0 16.3125 0 16C0 15.75 0.0625 15.5 0.3125 15.25L9.3125 7.24999C9.6875 6.93749 10.375 6.93749 10.6875 7.37499C11.0625 7.74999 11.0625 8.43749 10.625 8.74999ZM30.625 7.24999L39.625 15.25C39.875 15.5 40 15.75 40 16C40 16.3125 39.875 16.5625 39.625 16.75L30.625 24.75C30.25 25.125 29.5625 25.125 29.25 24.6875C28.875 24.25 28.875 23.625 29.3125 23.25L37.4375 16L29.3125 8.74999C28.875 8.43749 28.875 7.74999 29.25 7.37499C29.5625 6.93749 30.25 6.93749 30.625 7.24999Z"
      fill="currentColor"
    />
  </svg>

  <!-- GIF SVG -->
  <svg
    v-if="icon === 'gif'"
    class="h-full"
    viewBox="0 0 32 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M28 0H4C1.75 0 0 1.8125 0 4V24C0 26.25 1.75 28 4 28H28C30.1875 28 32 26.25 32 24V4C32 1.8125 30.1875 0 28 0ZM24 2V13H8V2H24ZM2 4C2 2.9375 2.875 2 4 2H6V7H2V4ZM2 9H6V13H2V9ZM2 15H6V19H2V15ZM4 26C2.875 26 2 25.125 2 24V21H6V26H4ZM8 26V15H24V26H8ZM30 24C30 25.125 29.0625 26 28 26H26V21H30V24ZM30 19H26V15H30V19ZM30 13H26V9H30V13ZM30 7H26V2H28C29.0625 2 30 2.9375 30 4V7Z"
      fill="currentColor"
    />
  </svg>

  <!-- SPACER SVG -->
  <svg
    v-if="icon === 'spacer'"
    class="h-full"
    viewBox="0 0 40 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M25.7188 9.28125C26.0938 9.65625 26.0938 10.3438 25.7188 10.7188C25.3438 11.0938 24.6562 11.0938 24.2812 10.7188L20.9688 7.40625V20.5938L24.2812 17.2812C24.6562 16.9062 25.3438 16.9062 25.7188 17.2812C26.0938 17.6562 26.0938 18.3438 25.7188 18.7188L20.7188 23.7188C20.3438 24.0938 19.6562 24.0938 19.2812 23.7188L14.2812 18.7188C13.9062 18.3438 13.9062 17.6562 14.2812 17.2812C14.6562 16.9062 15.3438 16.9062 15.7188 17.2812L19.0312 20.5938V7.40625L15.7188 10.7188C15.3438 11.0938 14.6562 11.0938 14.2812 10.7188C13.9062 10.3438 13.9062 9.65625 14.2812 9.28125L19.2812 4.28125C19.6562 3.90625 20.3438 3.90625 20.7188 4.28125L25.7188 9.28125Z"
      fill="currentColor"
    />
    <path
      d="M39 2H1C0.4375 2 0 1.5625 0 1C0 0.5 0.4375 0 1 0H39C39.5 0 40 0.5 40 1C40 1.5625 39.5 2 39 2Z"
      fill="currentColor"
    />
    <path
      d="M39 28H1C0.4375 28 0 27.5625 0 27C0 26.5 0.4375 26 1 26H39C39.5 26 40 26.5 40 27C40 27.5625 39.5 28 39 28Z"
      fill="currentColor"
    />
  </svg>

  <!-- PRODUCT SVG -->
  <svg
    v-if="icon === 'product' || icon === 'box'"
    class="h-full"
    viewBox="0 0 32 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.9375 0.376849C15.625 0.124384 16.3125 0.124384 17 0.376849L30 5.17369C31.1875 5.61551 32 6.7516 32 8.01393V24.3611C32 25.6234 31.1875 26.7595 30 27.2013L17 31.9982C16.3125 32.2506 15.625 32.2506 14.9375 31.9982L1.9375 27.2013C0.75 26.7595 0 25.6234 0 24.3611V8.01393C0 6.7516 0.75 5.61551 1.9375 5.17369L14.9375 0.376849ZM16.3125 2.27034C16.0625 2.14411 15.875 2.14411 15.625 2.27034L2.75 7.00407L16 12.2427L29.1875 7.00407L16.3125 2.27034ZM2.625 25.3078L15 29.9153V14.01L2 8.89756V24.3611C2 24.8029 2.25 25.1816 2.625 25.3078ZM17 29.9153L29.3125 25.3078C29.6875 25.1816 30 24.8029 30 24.3611V8.89756L17 14.01V29.9153Z"
      fill="currentColor"
    />
  </svg>

  <!-- DYNAMIC SVG -->
  <svg
    v-if="icon === 'dynamic' || icon === 'rss'"
    class="h-full"
    viewBox="0 0 36 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 0C7.5 0 8 0.499248 8 0.998495C8 1.56015 7.5 1.99699 7 1.99699H5.5C3.5625 1.99699 2 3.61954 2 5.49172V6.98947C2 7.55112 1.5 7.98796 1 7.98796C0.4375 7.98796 0 7.55112 0 6.98947V5.49172C0 2.49624 2.4375 0 5.5 0H7ZM0 16.9744V10.9834C0 10.4842 0.4375 9.98495 1 9.98495C1.5 9.98495 2 10.4842 2 10.9834V16.9744C2 17.5361 1.5 17.9729 1 17.9729C0.4375 17.9729 0 17.5361 0 16.9744ZM1 19.9699C1.5 19.9699 2 20.4691 2 20.9684V22.4661C2 24.4007 3.5625 25.9609 5.5 25.9609H7C7.5 25.9609 8 26.4601 8 26.9594C8 27.521 7.5 27.9579 7 27.9579H5.5C2.4375 27.9579 0 25.524 0 22.4661V20.9684C0 20.4691 0.4375 19.9699 1 19.9699ZM27.0625 10.0474C26.5 10.1098 26 9.67292 26 9.11127V5.49172C26 3.61954 24.375 1.99699 22.5 1.99699H21C20.4375 1.99699 20 1.56015 20 0.998495C20 0.499248 20.4375 0 21 0H22.5C25.5 0 28 2.49624 28 5.49172V9.11127C28 9.61051 27.5625 9.98495 27.0625 10.0474ZM10 26.9594C10 26.4601 10.4375 25.9609 11 25.9609H17C17.5 25.9609 18 26.4601 18 26.9594C18 27.521 17.5 27.9579 17 27.9579H11C10.4375 27.9579 10 27.521 10 26.9594ZM17 1.99699H11C10.4375 1.99699 10 1.56015 10 0.998495C10 0.499248 10.4375 0 11 0H17C17.5 0 18 0.499248 18 0.998495C18 1.56015 17.5 1.99699 17 1.99699ZM34 20.9684C34 15.6015 28.125 12.2316 23.5 14.9774C21.3125 16.2255 20 18.4722 20 20.9684C20 26.3977 25.8125 29.7676 30.5 27.0218C32.625 25.7737 34 23.527 34 20.9684ZM18 20.9684C18 14.1037 25.5 9.73533 31.5 13.2301C34.25 14.8526 36 17.7857 36 20.9684C36 27.8955 28.5 32.2639 22.5 28.7691C19.6875 27.1466 18 24.2135 18 20.9684ZM28 16.9744V19.9699H31C31.5 19.9699 32 20.4691 32 20.9684C32 21.5301 31.5 21.9669 31 21.9669H28V24.9624C28 25.524 27.5 25.9609 27 25.9609C26.4375 25.9609 26 25.524 26 24.9624V21.9669H23C22.4375 21.9669 22 21.5301 22 20.9684C22 20.4691 22.4375 19.9699 23 19.9699H26V16.9744C26 16.4752 26.4375 15.9759 27 15.9759C27.5 15.9759 28 16.4752 28 16.9744Z"
      fill="currentColor"
    />
  </svg>

  <!-- CAROUSEL SVG -->
  <svg
    v-if="icon === 'carousel'"
    class="h-full"
    viewBox="0 0 36 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M36 4C36 1.8125 34.1875 0 32 0H4C1.75 0 0 1.8125 0 4V16C0 18.25 1.75 20 4 20H32C34.1875 20 36 18.25 36 16V4ZM4 2H32C33.0625 2 34 2.9375 34 4V16C34 17.125 33.0625 18 32 18H4C2.875 18 2 17.125 2 16V4C2 2.9375 2.875 2 4 2ZM8 24C9.0625 24 10 24.9375 10 26V30C10 31.125 9.0625 32 8 32H4C2.875 32 2 31.125 2 30V26C2 24.9375 2.875 24 4 24H8ZM8 26H4V30H8V26ZM22 26C22 24.9375 21.0625 24 20 24H16C14.875 24 14 24.9375 14 26V30C14 31.125 14.875 32 16 32H20C21.0625 32 22 31.125 22 30V26ZM16 26H20V30H16V26ZM34 26C34 24.9375 33.0625 24 32 24H28C26.875 24 26 24.9375 26 26V30C26 31.125 26.875 32 28 32H32C33.0625 32 34 31.125 34 30V26ZM28 26H32V30H28V26Z"
      fill="currentColor"
    />
  </svg>

  <!-- ARTICLE SVG -->
  <svg
    v-if="icon === 'article'"
    class="mb-[3px] h-full"
    viewBox="0 0 32 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M29 0H9C7.3125 0 6 1.375 6 3V24C6 25.125 5.0625 26 4 26C2.875 26 2 25.125 2 24V5C2 4.5 1.5 4 1 4C0.4375 4 0 4.5 0 5V24C0 26.25 1.75 28 4 28H27C29.75 28 32 25.8125 32 23V3C32 1.375 30.625 0 29 0ZM30 23C30 24.6875 28.625 26 27 26H7.4375C7.75 25.4375 8 24.75 8 24V3C8 2.5 8.4375 2 9 2H29C29.5 2 30 2.5 30 3V23ZM17 17H11C10.4375 17 10 17.5 10 18C10 18.5625 10.4375 19 11 19H17C17.5 19 18 18.5625 18 18C18 17.5 17.5 17 17 17ZM27 17H21C20.4375 17 20 17.5 20 18C20 18.5625 20.4375 19 21 19H27C27.5 19 28 18.5625 28 18C28 17.5 27.5 17 27 17ZM17 21H11C10.4375 21 10 21.5 10 22C10 22.5625 10.4375 23 11 23H17C17.5 23 18 22.5625 18 22C18 21.5 17.5 21 17 21ZM27 21H21C20.4375 21 20 21.5 20 22C20 22.5625 20.4375 23 21 23H27C27.5 23 28 22.5625 28 22C28 21.5 27.5 21 27 21ZM26 4H12C10.875 4 10 4.9375 10 6V12C10 13.125 10.875 14 12 14H26C27.0625 14 28 13.125 28 12V6C28 4.9375 27.0625 4 26 4ZM26 12H12V6H26V12Z"
      fill="currentColor"
    />
  </svg>

  <!-- RATING SVG -->
  <svg
    v-if="icon === 'rating'"
    class="h-full"
    viewBox="0 0 40 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="1"
      y="1"
      width="6"
      height="18"
      rx="2"
      stroke="currentColor"
      stroke-width="1.5"
      fill="none"
    />
    <rect
      x="9"
      y="1"
      width="6"
      height="18"
      rx="2"
      stroke="currentColor"
      stroke-width="1.5"
      fill="none"
    />
    <rect
      x="17"
      y="1"
      width="6"
      height="18"
      rx="2"
      stroke="currentColor"
      stroke-width="1.5"
      fill="none"
    />
    <rect
      x="25"
      y="1"
      width="6"
      height="18"
      rx="2"
      stroke="currentColor"
      stroke-width="1.5"
      fill="none"
    />
    <rect
      x="33"
      y="1"
      width="6"
      height="18"
      rx="2"
      stroke="currentColor"
      stroke-width="1.5"
      fill="none"
    />
  </svg>

  <!-- LOOP SVG -->
  <svg
    v-if="icon === 'loop'"
    class="h-full"
    viewBox="0 0 64 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16 5C16 4.44772 16.4477 4 17 4C17.5523 4 18 4.44772 18 5V6C18 7.125 18.875 8 20 8H44C45.0625 8 46 7.125 46 6V5C46 4.44772 46.4477 4 47 4C47.5523 4 48 4.44772 48 5V6C48 8.25 46.1875 10 44 10H20C17.75 10 16 8.25 16 6V5ZM48 31C48 31.5523 47.5523 32 47 32C46.4477 32 46 31.5523 46 31V30C46 28.875 45.125 28 44 28L20 28C18.9375 28 18 28.875 18 30V31C18 31.5523 17.5523 32 17 32C16.4477 32 16 31.5523 16 31V30C16 27.75 17.8125 26 20 26L44 26C46.25 26 48 27.75 48 30V31ZM50 12H14C11.7909 12 10 13.7909 10 16V20C10 22.2091 11.7909 24 14 24H50C52.2091 24 54 22.2091 54 20V16C54 13.7909 52.2091 12 50 12ZM12 16C12 14.8954 12.8954 14 14 14H50C51.1046 14 52 14.8954 52 16V20C52 21.1046 51.1046 22 50 22H14C12.8954 22 12 21.1046 12 20V16Z"
      fill="currentColor"
    />
  </svg>
</template>

<script lang="ts" setup>
  defineProps({
    icon: {
      type: String,
      default: "text",
    },
  });
</script>

<style></style>
